import React from "react";
import Barcode from "react-barcode";
import moment from "moment";
import SummeryTable from "./SummeryTable";
import { formatDecimal } from "../../../../hooks/Method";

const PrintReceipt = ({ data }) => {
  return (
    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
      <div
        style={{
          fontFamily: "Arial, sans-serif",
          maxWidth: "400px",
          margin: "0 auto",
          padding: "20px",
          border: "1px solid #ddd",
          display: "grid",
        }}
      >
        {/* Header  */}
        {data.outlet && (
          <div
            style={{
              display: "grid",
              gap: "5px",
              textAlign: "center",
              justifyContent: "center",
            }}
          >
            <span
              style={{
                fontSize: "26px",
                fontWeight: "bold",
                textTransform: "uppercase",
              }}
            >
              Return Sell Receipt
            </span>
            <span style={{ fontSize: "20px", fontWeight: "400" }}>
              {data.outlet.outletName}
            </span>
            <span>{data.outlet.address1}</span>
            {data.outlet.address2 && <span>{data.outlet.address2}</span>}
            <span>
              {data.outlet.city}, {data.outlet.state} {data.outlet.zip}
            </span>
            <span>Tell: {data.outlet.phone}</span>
          </div>
        )}

        {/* Cashier Details */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
            borderBottom: "2px solid #ddd",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <span style={{ fontWeight: "400" }}>
              Cashier:{" "}
              {data.user && data.user.firstName + " " + data.user.lastName}
            </span>
            {data.didReturn && (
              <span
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                }}
              >
                Items Returned in this sale
              </span>
            )}
          </div>
          <div style={{ display: "grid", gap: "5px" }}>
            <span style={{}}>
              Date: {moment(data.returnDate).format("ddd, DD MMM YYYY")}
            </span>
            <span style={{}}>
              Time: {moment(data.returnDate).format("hh:mm A")}
            </span>
          </div>
        </div>

        {/* Customer Details */}
        {data.customer && (
          <div
            style={{
              gap: "2px",
              borderBottom: "2px solid #ddd",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
              }}
            >
              <p style={{ fontWeight: "400" }}>
                Customer:{" "}
                {data.customer.firstName + " " + data.customer.lastName}
              </p>

              <span>|</span>
              <p style={{ fontWeight: "400" }}>{data.customer.cstmrCode}</p>
            </div>
          </div>
        )}

        <table
          style={{
            width: "100%",
            marginTop: "20px",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  paddingBottom: "15px",
                  textTransform: "uppercase",
                }}
              >
                Item
              </th>
              <th
                style={{
                  textAlign: "right",
                  paddingBottom: "15px",
                  textTransform: "uppercase",
                }}
              >
                Return Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {data.returnItems.map((item, ind) => (
              <tr
                key={ind}
                style={{
                  borderBottom: `${
                    data.returnItems.length !== ind + 1
                      ? "1px solid #ddd"
                      : "none"
                  }`,
                }}
              >
                <td
                  style={{
                    maxWidth: "200px",
                    padding: "5px 0px",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gap: "3px",
                    }}
                  >
                    {/* Product Name */}
                    <span style={{ fontSize: "14px", fontWeight: "400" }}>
                      {item.prod.name}
                    </span>
                    {/* Product Variant Name */}
                    <span style={{ fontSize: "12px", fontWeight: "400" }}>
                      {item.varProd &&
                        `${item.varProd.attrVal1} ${
                          item.varProd.attrVal2 && " / " + item.varProd.attrVal2
                        } ${
                          item.varProd.attrVal3 && " / " + item.varProd.attrVal3
                        } | `}
                      Return Qty: {item.returnQty}
                      {parseFloat(item.discAdj) > 0 &&
                        ` | Discount Adj. :  $ ${item.discAdj}`}
                    </span>
                  </div>
                </td>
                <td
                  style={{
                    textAlign: "right",
                    padding: "5px 0px",
                  }}
                >
                  <div style={{ display: "grid", gap: "2px" }}>
                    <span
                      style={{
                        marginBottom: "5px",
                      }}
                    >
                      $ {formatDecimal(item.returnAmt)}
                    </span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ borderBottom: "3px solid #8f8f8f", marginTop: "10px" }} />

        {/* Accounts Summery */}
        <SummeryTable {...{ data }} />

        <div style={{ borderBottom: "3px solid #bfbfbf", marginTop: "10px" }} />

        <div
          style={{
            paddingTop: "15px",
            paddingBottom: "5px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Barcode value={data.id.toString()} />
        </div>

        <div style={{ borderBottom: "3px solid #bfbfbf", marginTop: "10px" }} />
        <p
          style={{
            textAlign: "center",
            marginTop: "20px",
            fontSize: "22px",
            fontWeight: "bold",
            color: "#6f6f6f",
            textTransform: "uppercase",
            letterSpacing: "5px",
          }}
        >
          * Thank you *
        </p>
      </div>
    </div>
  );
};

export default PrintReceipt;
